<script>
  import textInput from './text-input.vue'
  import {
    checkLastNameMaxLength,
    checkLastNameRegex,
    LAST_NAME_MAX_LENGTH
  } from '../helpers/field-checker.helper';
  import { F_ERR_ENUM } from '../enum/field-error.enum';
  export default {
    extends: textInput,
    name: 'lastname-input',
    methods: {
      computeErrors () {
        if (!checkLastNameMaxLength(this.content.trim())) {
          this.setError(F_ERR_ENUM.INCORRECT, this.$t('lastname-input.invalidMax', LAST_NAME_MAX_LENGTH));
          return;
        }
        if (!checkLastNameRegex(this.content.trim())) {
          this.setError(F_ERR_ENUM.INCORRECT, this.$t('lastname-input.invalidRegex'));
          return;
        }
        this.setError(F_ERR_ENUM.INCORRECT, null);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lastname-input.vue